import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { Project } from '../../resource/';
import { ListProjects } from './ListProjects';
import { Gate } from '../../controls/Gate';

const ProjectList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  // Go to add project view.
  const handleAdd = () => {
    navigate('/projects/add');
  }  

  // Go to view project view.
  const handleClick = (item: Project) => {
    navigate(`/projects/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListProjects auth={auth} name="projects" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_projects'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add project</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { ProjectList }
